import type { TOC } from '@ember/component/template-only';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { gt, lt } from 'ember-truth-helpers';
import { IncrementFor } from 'frontend-utils';

interface HotelStrategyTablesCellsTdFrequencySignature {
  Args: {
    cellData: {
      formattedValue?: string;
      hasNoData?: boolean;
      value: string;
    };
  };
}

const HotelStrategyTablesCellsTdFrequency = <template>
  {{#if @cellData.hasNoData}}
    {{@cellData.formattedValue}}
  {{else}}
    <div class="flex items-center justify-center gap-50">
      <IncrementFor @times={{5}} as |index|>
        <div
          class="bucket {{if (lt index @cellData.value) 'bucket--filled'}}"
        />
      </IncrementFor>
    </div>
    {{#if (gt @cellData.value 0)}}
      <EmberTooltip
        @tooltipClass="base-tooltip rates-table-tooltip display-over-modal"
      >
        <div class="rates-table-tooltip-container">
          <table cellspacing="0">
            <tbody>
              <tr>
                <td>{{@cellData.formattedValue}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </EmberTooltip>
    {{/if}}
  {{/if}}
</template> satisfies TOC<HotelStrategyTablesCellsTdFrequencySignature>;

export default HotelStrategyTablesCellsTdFrequency;
